import { PATHS } from '@belong/common';
import { ApplicationDetails, CoApplicantModel } from 'src/api/models';

export function getCurrentApplication(
  homeId: string,
  listingId: string,
  applications: ApplicationDetails[] | undefined,
) {
  return applications?.find((application) =>
    application.listingDetails?.find(
      (listingDetails) =>
        listingDetails.home?.unitId === homeId &&
        listingDetails.listing?.uniqueId === listingId,
    ),
  );
}

export function getCurrentApplicationUserStatus(
  userEmail: string | undefined,
  currentApplication: ApplicationDetails | undefined,
) {
  if (!userEmail || !currentApplication) {
    return;
  }

  return [
    currentApplication?.applicants?.mainApplicant,
    ...(currentApplication?.applicants?.coApplicants || []),
    ...(currentApplication?.applicants?.coSigners || []),
  ].find((applicant) => applicant?.email === userEmail)?.status;
}

export function getLabel(
  isDemoUnit: boolean,
  canApply: boolean,
  currentApplicationUserStatus: CoApplicantModel['status'] | undefined | null,
  isBlocked = false,
) {
  if (isDemoUnit) {
    return 'Unavailable';
  } else if (isBlocked) {
    return 'Not Yet Available';
  } else if (!canApply) {
    return 'Loved';
  } else if (
    currentApplicationUserStatus &&
    ['Started', 'Invited'].includes(currentApplicationUserStatus)
  ) {
    return 'Complete Application';
  } else if (
    currentApplicationUserStatus &&
    ['Submitted', 'VerificationsCompleted'].includes(
      currentApplicationUserStatus,
    )
  ) {
    return 'View Application';
  }

  return 'Apply';
}

export function getHref(
  homeId: string,
  userEmail: string | undefined,
  currentApplication: ApplicationDetails | undefined | null,
  currentApplicationUserStatus: CoApplicantModel['status'] | undefined | null,
) {
  const currentApplicationId =
    currentApplication?.basicInfo?.applicationId || '';

  if (currentApplicationId && currentApplicationUserStatus) {
    if (['Started', 'Invited'].includes(currentApplicationUserStatus)) {
      const isMainApplicant =
        currentApplication?.applicants?.mainApplicant?.email === userEmail;

      return (
        isMainApplicant
          ? PATHS.RESIDENT_APPLICATION_LEASE_STEP
          : PATHS.RESIDENT_APPLICATION_PRE_APPLICANT_FLOW
      ).concat(`?applicationId=${currentApplication}&homeId=${homeId}`);
    } else if (
      ['Submitted', 'VerificationsCompleted'].includes(
        currentApplicationUserStatus,
      )
    ) {
      return PATHS.RESIDENTS_ACCOUNT_TOURS_AND_APPS;
    }
  }

  return PATHS.RESIDENT_APPLICATION_GET_STARTED.concat(`?homeId=${homeId}`);
}
